import type { ReactNode } from "react";
import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * The row ABOVE a page's heading: the back button, then an optional navigation path (owner 2026-11-02). Keeping back up
 * here gives the heading the full width and puts back in the same place on every page. Navigation look per arc-conventions
 * §3: outline + text, the arrow on the left.
 */
export function PageBackRow({ label, onBack, children }: { label: string; onBack: () => void; children?: ReactNode }) {
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2">
      <Button variant="outline" size="sm" onPress={onBack} className="shrink-0">
        <ChevronLeft aria-hidden="true" />
        {label}
      </Button>
      {children}
    </div>
  );
}
